module.exports = __webpack_public_path__ + "img/avatar5.b52c0320.png";